import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { InputControlBase } from './../forms/input-control.base';

/** @deprecated Use `astral-input` in new or Astralized templates. */
@Component({
    selector: 'app-text-box',
    templateUrl: './text-box.component.html',
    styleUrls: ['./text-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextBoxComponent extends InputControlBase implements AfterViewInit {
  constructor(
    private _router: Router,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  @Input() textAlignCenter: boolean = false;
  @Input() clearOthers: boolean;
  @Input() doNotDisplayClear: boolean;
  @Input() fieldType: string = '';
  @Input() focused: boolean = false;
  @Output() addonClick = new EventEmitter<FormControl>();

  @ViewChild('input') input: ElementRef;

  @HostBinding('tabindex') tabindex = -1;

  @HostListener('focus')
  focusHandler() {
    this.input.nativeElement.focus();
  }

  get showClearOthers(): boolean {
    if (!this.clearOthers) {
      return false;
    }
    return Object.keys(this.control?.parent.controls).length > 1 && (this.control?.value || this.control?.value === 0);
  }

  get showClearThis(): boolean {
    return !this.control?.isReadonly && !this.doNotDisplayClear;
  }

  ngAfterViewInit(): void {
    if (this.focused) {
      this.focusHandler();
      this._cd.detectChanges();
    }
  }

  addonClicked(): boolean {
    for (let controlName of Object.keys(this.control.parent.controls)) {
      let currentControl = this.control.parent.get(controlName);
      if (currentControl !== this.control) {
        currentControl.setValue(undefined);
      }
    }

    this.addonClick.emit(this.control);
    return false;
  }

  get paddingClass(): any {
    return { addonPadding: this.showClearOthers };
  }

  showAddonHelp = false;

  onAddonMouseEnter() {
    this.showAddonHelp = true;
  }

  onAddonMouseLeave() {
    this.showAddonHelp = false;
  }

  clearBtnClicked(): boolean {
    // this.onClearBtnMouseLeave();
    if (!this.control.parent) {
      this.control.setValue(undefined);
      return;
    }
    for (let controlName of Object.keys(this.control.parent.controls)) {
      let currentControl = this.control.parent.get(controlName);
      if (currentControl === this.control) {
        this.onfocus();
        currentControl.setValue(undefined);
        let form = this.control.parent;
        while (form.parent) form = form.parent;
        form.markAsDirty();
        this.onblur();
      }
    }

    this.addonClick.emit(this.control);
    return false;
  }

  sendEmail() {
    if (!this.control.value) {
      return;
    }

    this._router.navigateByUrl('/dh/email/send-generic?tmpusr=' + encodeURIComponent(this.control.value));
  }
}
